  <mat-toolbar>
    <a class="nav-link brand-link" [routerLink]="brandLandingRoute" matTooltip="Sprinta.io Home">
      <span class="brand-logo-mark">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </svg>
      </span>
      <span class="brand-text">
        <span class="brand-name">sprinta</span><span class="brand-tld">.io</span>
      </span>
    </a>

    <div class="brand-divider hide-xs"></div>

    <!-- Combined User & Project Selector Widget (Desktop: hide-xs) -->
    <div class="user-workspace-widget hide-xs">
      <button mat-button class="workspace-pill-btn" [matMenuTriggerFor]="contextMenu" [matTooltip]="(currentUser?.displayName || 'User') + ' • ' + (currentProject?.name || 'Project')">
        <span class="role-avatar-badge" [style.color]="roleColor()">
          <mat-icon>{{ userService.getRoleIcon() }}</mat-icon>
        </span>
        <span class="user-name-label">{{ currentUser?.displayName || currentUser?.email || 'User' }}</span>
        <span class="widget-divider">/</span>
        <span class="project-name-label">{{ currentProject?.name || 'Select Project' }}</span>
        <span class="role-badge-pill" [style.background-color]="roleColor()">{{ roleBadge() }}</span>

        <span class="dropdown-arrow-wrap">
          <mat-icon class="dropdown-arrow">expand_more</mat-icon>
        </span>
      </button>

      <!-- Combined Context Menu (Desktop) -->
      <mat-menu #contextMenu="matMenu" class="user-workspace-menu">
        <!-- User Profile Quick Header -->
        <div class="menu-user-header" [routerLink]="['/p', activeProjectId, 'u', 'profile']" matTooltip="View Profile">
          <div class="menu-user-avatar" [style.background-color]="roleColor()">
            <mat-icon>{{ userService.getRoleIcon() }}</mat-icon>
          </div>
          <div class="menu-user-info">
            <span class="menu-user-name">{{ currentUser?.displayName || currentUser?.email || 'User' }}</span>
            <span class="menu-user-email">{{ currentUser?.email }}</span>
            <span class="menu-user-role" [style.color]="roleColor()">{{ roleBadge() }}</span>
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Projects Section -->
        <div class="project-menu-header">
          <span class="header-label">Projects</span>
          <span class="header-count">{{ userProjects.length }}</span>
        </div>

        @for (p of userProjects; track p.id) {
          <button mat-menu-item (click)="switchProject(p.id)" [class.active-project-item]="p.id === activeProjectId">
            <mat-icon class="check-icon" [color]="p.id === activeProjectId ? 'primary' : ''">
              {{ p.id === activeProjectId ? 'check' : 'folder_open' }}
            </mat-icon>
            <span class="menu-project-name">{{ p.name }}</span>
            <span class="project-role-chip">{{ formatProjectRole(p.role) }}</span>
          </button>
        }

        <mat-divider></mat-divider>
        <button mat-menu-item (click)="openCreateProjectDialog()">
          <mat-icon>add</mat-icon>
          <span>Create New Project...</span>
        </button>
        <button mat-menu-item (click)="navigateToProjects()">
          <mat-icon>grid_view</mat-icon>
          <span>Manage All Projects</span>
        </button>
        <button mat-menu-item [routerLink]="['/p', activeProjectId, 'u', 'profile']">
          <mat-icon>manage_accounts</mat-icon>
          <span>Account Settings</span>
        </button>
      </mat-menu>
    </div>

    <span class="toolbar-spacer"></span>

    <!-- Navigation links (Conditional on role permissions, Desktop: hide-xs) -->
    <a class="nav-link hide-xs" [routerLink]="['/p', activeProjectId, 't', 'roadmap']" matTooltip="Roadmap"><mat-icon class="nav-icon" aria-hidden="false" aria-label="Roadmap" fontIcon="add_road"></mat-icon></a>        
    
    @if (canViewBacklog) {
      <a class="nav-link hide-xs" [routerLink]="['/p', activeProjectId, 't', 'backlog']" matTooltip="Backlog"><mat-icon class="nav-icon" aria-hidden="false" aria-label="Backlog" fontIcon="format_list_bulleted_add"></mat-icon></a>    
      <a class="nav-link hide-xs" [routerLink]="['/p', activeProjectId, 't', 'triage']" matTooltip="Public Task Triage"><mat-icon class="nav-icon" aria-hidden="false" aria-label="Public Task Triage" fontIcon="add_task"></mat-icon></a>
    }
    @if (canViewSprint) {
      <a class="nav-link hide-xs" [routerLink]="['/p', activeProjectId, 't', 'sprint']" matTooltip="Sprints"><mat-icon class="nav-icon" aria-hidden="false" aria-label="Sprints" fontIcon="segment"></mat-icon></a>    
    }
    @if (canViewTeams) {
      <a class="nav-link hide-xs" [routerLink]="['/p', activeProjectId, 'u', 'team']" matTooltip="Teams"><mat-icon class="nav-icon" aria-hidden="false" aria-label="Teams" fontIcon="people"></mat-icon></a>
    }

    <a class="nav-link hide-xs" [routerLink]="['/p', activeProjectId, 'u', 'profile']" matTooltip="Profile"><mat-icon class="nav-icon" aria-hidden="false" aria-label="Profile" fontIcon="manage_accounts"></mat-icon></a>    

    <button matMiniFab color="primary" class="hide-gt-xs button" [matMenuTriggerFor]="menu" aria-label="Toggle Navigation Menu"><mat-icon>menu</mat-icon></button>
  </mat-toolbar>

  @if (isExpiringSoon) {
    <div class="system-banner warning">
      <mat-icon>warning_amber</mat-icon>
      <div class="banner-text">
        <strong>Subscription Renewal:</strong>
        <span>Your annual subscription renews in {{ projectSubscription?.daysRemaining }} days.</span>
      </div>
      @if (isOwner) {
        <button mat-flat-button class="banner-action-btn warn-btn" (click)="openSubscriptionModal(1)">
          <mat-icon>payment</mat-icon> Renew Now
        </button>
      }
    </div>
  } @else if (isGracePeriod) {
    <div class="system-banner grace">
      <mat-icon>timer</mat-icon>
      <div class="banner-text">
        <strong>Grace Period Active:</strong>
        <span>Subscription renewal was due on {{ projectSubscription?.currentPeriodEnd | date:'mediumDate' }}. 15-day grace period is active before account actions are locked.</span>
      </div>
      @if (isOwner) {
        <button mat-flat-button class="banner-action-btn grace-btn" (click)="openSubscriptionModal(1)">
          <mat-icon>payment</mat-icon> Pay & Renew Now
        </button>
      }
    </div>
  } @else if (isBlocked) {
    <div class="system-banner blocked">
      <mat-icon>lock</mat-icon>
      <div class="banner-text">
        <strong>Account Actions Blocked:</strong>
        <span>
          @if (isOwner) {
            Your subscription expired and the 15-day grace period has ended. Please renew to resume access.
          } @else {
            Your project's subscription is currently expired. Please contact your Project Owner ({{ ownerName }}) to renew access.
          }
        </span>
      </div>
      @if (isOwner) {
        <button mat-flat-button class="banner-action-btn blocked-btn" (click)="openSubscriptionModal(1)">
          <mat-icon>lock_open</mat-icon> {{ pricing.display.renewalBannerText }}
        </button>
      }
    </div>
  }

  
  @if (isLiveMode && !isApiOnline) {
    <div class="system-banner offline-banner">
      <mat-icon>cloud_off</mat-icon>
      <div class="banner-text">
        <strong>Sprinta Cloud API Offline:</strong>
        <span>Unable to reach {{ apiBaseUrl }}. The backend API is currently unavailable. Data is not falling back to local storage to protect state integrity.</span>
      </div>
      <button mat-flat-button class="banner-action-btn offline-btn" (click)="checkHealth()">
        <mat-icon>refresh</mat-icon> Retry Connection
      </button>
    </div>
  }

  <ng-content></ng-content>
  
<mat-menu #menu="matMenu" class="mobile-nav-menu">
  <ng-template matMenuContent>
    <div class="column-menu">
      <!-- Mobile User & Role Header -->
      <div class="mobile-user-header" [routerLink]="['/p', activeProjectId, 'u', 'profile']">
        <div class="mobile-avatar" [style.background-color]="roleColor()">
          <mat-icon>{{ userService.getRoleIcon() }}</mat-icon>
        </div>
        <div class="mobile-user-meta">
          <span class="mobile-user-name">{{ currentUser?.displayName || currentUser?.email || 'User' }}</span>
          <span class="mobile-user-badge" [style.background-color]="roleColor()">{{ roleBadge() }}</span>
        </div>
      </div>

      <mat-divider></mat-divider>

      <!-- Mobile Project Switcher Submenu Trigger -->
      <button mat-menu-item [matMenuTriggerFor]="mobileProjectSubmenu" class="mobile-project-item">
        <mat-icon class="proj-icon">folder</mat-icon>
        <div class="proj-label-col">
          <span class="proj-sub">Project</span>
          <span class="proj-name">{{ currentProject?.name || 'Select Project' }}</span>
        </div>
      </button>

      <mat-divider></mat-divider>

      <a class="nav-link" [routerLink]="['/p', activeProjectId, 't', 'roadmap']"><mat-icon class="nav-icon" fontIcon="add_road"></mat-icon> <span>Roadmap</span></a>    
      @if (canViewBacklog) {
        <a class="nav-link" [routerLink]="['/p', activeProjectId, 't', 'backlog']"><mat-icon class="nav-icon" fontIcon="format_list_bulleted_add"></mat-icon> <span>Backlog</span></a>    
        <a class="nav-link" [routerLink]="['/p', activeProjectId, 't', 'triage']"><mat-icon class="nav-icon" fontIcon="add_task"></mat-icon> <span>Triage</span></a>
      }
      @if (canViewSprint) {
        <a class="nav-link" [routerLink]="['/p', activeProjectId, 't', 'sprint']"><mat-icon class="nav-icon" fontIcon="segment"></mat-icon> <span>Sprints</span></a>    
      }
      @if (canViewTeams) {
        <a class="nav-link" [routerLink]="['/p', activeProjectId, 'u', 'team']"><mat-icon class="nav-icon" fontIcon="people"></mat-icon> <span>Teams</span></a>
      }
      <a class="nav-link" [routerLink]="['/p', activeProjectId, 'u', 'profile']"><mat-icon class="nav-icon" fontIcon="manage_accounts"></mat-icon> <span>Profile</span></a>          
      <mat-divider></mat-divider>
      <a class="nav-link" [routerLink]="['/projects']"><mat-icon class="nav-icon" fontIcon="grid_view"></mat-icon> <span>All Projects</span></a>
    </div>
  </ng-template>
</mat-menu>

<!-- Mobile Project Submenu -->
<mat-menu #mobileProjectSubmenu="matMenu" class="user-workspace-menu">
  <div class="project-menu-header">
    <span class="header-label">Switch Project</span>
    <span class="header-count">{{ userProjects.length }}</span>
  </div>
  <mat-divider></mat-divider>
  @for (p of userProjects; track p.id) {
    <button mat-menu-item (click)="switchProject(p.id)" [class.active-project-item]="p.id === activeProjectId">
      <mat-icon class="check-icon" [color]="p.id === activeProjectId ? 'primary' : ''">
        {{ p.id === activeProjectId ? 'check' : 'folder_open' }}
      </mat-icon>
      <span class="menu-project-name">{{ p.name }}</span>
      <span class="project-role-chip">{{ formatProjectRole(p.role) }}</span>
    </button>
  }
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="openCreateProjectDialog()">
    <mat-icon>add</mat-icon>
    <span>Create New Project...</span>
  </button>
  <button mat-menu-item (click)="navigateToProjects()">
    <mat-icon>grid_view</mat-icon>
    <span>Manage All Projects</span>
  </button>
</mat-menu>